@if (!isMobile) {
  <div>
    <div class="driver-list-page">
      @if (vehicles.length > 1) {
        <div class="back-arrow">
          <img class="arrow-back" (click)="goToDriverPlans()" rtlDiv src="assets/images/workplans-page/arrow-back.svg" alt="arrow-back">
          <span class="back-lbl">{{ 'SITE_MANAGMENT.BACK' | translate }}</span>
        </div>
      }
      <div class="header" rtlDiv>
        <div class="title">{{'DRIVER_PLAN.BINS_LEFT' | translate}}: {{binsNotCollected}}</div>
        <div class="plan-info-container">
          <div class="site-truck-info">
            <div class="plan-info">
              <img rtlDiv src="assets/images/workplans-page/site-name.svg" alt="site-name">
              <span>{{chosenPlan ? chosenPlan.site_name : ''}}</span>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="plan-info">
              <img rtlDiv src="assets/images/workplans-page/truck-name.svg" alt="truck-name">
              <span>{{'TRUCK_MAP.TRUCK' | translate }} {{chosenPlan ? chosenPlan.tablet_id : ''}}</span>
            </div>
          </div>
          <div class="sub-title">{{'DRIVER_PLAN.LAST_UPDATE' | translate}}:
            {{(currentLang == 'iw' ? utilService.convertDateHebrew(lastUpdatedTime) : utilService.convertDateEnglish(lastUpdatedTime))}}
          </div>
        </div>
      </div>
      <div class="bins-list">
        <div class="outside-table-border">
            <table class="table" mat-table #table multiTemplateDataRows [dataSource]="dataSource" matSort matSortStart="asc" matSortActive="bin_collection_order_index"
              matSortDisableClear (matSortChange)="sortData($event)" matSortDirection="asc">
              <ng-container matColumnDef="bin_collection_order_index">
                <th class="th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_collection_order_index"># </th>
                <td class="td-value" mat-cell *matCellDef="let element">
                  {{element ? element.bin_collection_order_index: ''}}
                </td>
              </ng-container>
              <ng-container matColumnDef="cluster_size">
                <th class="th-title" mat-header-cell *matHeaderCellDef mat-sort-header="num_of_bins_in_cluster">{{'DRIVER_PLAN.CLUSTER_SIZE' | translate}}</th>
                <td class="td-value" mat-cell *matCellDef="let element">
                  {{element ? element.num_of_bins_in_cluster : ''}}
                </td>
              </ng-container>
              <ng-container matColumnDef="bin_name">
                <th class="th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_name">{{ 'LIST_COLUMNS.NAME' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <div class="flexOnly">
                    @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                      <div class="multiple-bins">
                        @for (bin of element.bins_in_cluster; track bin.bin_id) {
                          <div class="bin-item gap8">
                            <span class="td-value">{{bin.bin_name}}</span>
                            <img src="{{getImg(bin)}}" alt="" />
                          </div>
                        }
                      </div>
                    } @else {
                      <span class="td-value"> {{element ? element.bin_name : ''}}</span>
                      <img src="{{element ? getImg(element) : ''}}" alt="" />
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="neighborhood">
                <th class="th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_neighbourhood">{{'LIST_COLUMNS.NEIGHBORHOOD' | translate}}</th>
                <td class="td-value" mat-cell *matCellDef="let element">
                  <div>
                    @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                      <div class="multiple-bins">
                        @for (bin of element.bins_in_cluster; track bin.bin_id) {
                          <div class="bin-item">
                            <span class="td-value">{{bin['Bin_location']['bin_neighbourhood']}}</span>
                          </div>
                        }
                      </div>
                    } @else {
                      <span class="td-value"> {{element ? element['Bin_location']['bin_neighbourhood'] : ''}}</span>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="address">
                <th class="th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_address"> {{ 'LIST_COLUMNS.ADDRESS' | translate }}</th>
                <td class="td-value" mat-cell *matCellDef="let element">
                  <div class="address-val">
                    @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                      <div class="multiple-bins">
                        @for (bin of element.bins_in_cluster; track bin.bin_id) {
                          <div class="bin-item gap4">
                            <a class="wazeFrame" href='https://waze.com/ul?ll={{bin.Bin_location.bin_latitude}},{{bin.Bin_location.bin_longitude}}'><img class="mobile-wazeIcon" src="assets/images/dashboard/mobile-waze.svg" alt=""></a>
                            <span class="td-value">{{bin['Bin_location']['bin_address']}}</span>
                          </div>
                        }
                      </div>
                    } @else {
                      <a class="wazeFrame" href='https://waze.com/ul?ll={{element.Bin_location.bin_latitude}},{{element.Bin_location.bin_longitude}}'><img class="mobile-wazeIcon" src="assets/images/dashboard/mobile-waze.svg" alt=""></a>
                      <span class="td-value"> {{element ? element['Bin_location']['bin_address'] : ''}}</span>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th class="th-title" mat-header-cell *matHeaderCellDef mat-sort-header="fill_level">{{ 'LIST_COLUMNS.STATUS' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <div>
                    @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                      <div class="multiple-bins">
                        @for (bin of element.bins_in_cluster; track bin.bin_id) {
                          <div class="bin-item">
                            <div class="dFlex">
                              <div class="table-status-progress-bar-wrapper progress" [ngStyle]="getProgressBarStyleWrapper(bin)">
                                <div class="table-status-progress-line progress-bar" [ngStyle]="getProgressBarStyleInternal(bin)"></div>
                              </div>
                              <div class='table-status-progress-bar-title'>
                                {{capacityDisplayType !=0 ? bin['Last_updated_fill_level_sample']['fill_level_in_litters']: bin['Last_updated_fill_level_sample']['fill_level_in_precent']}}
                                <span>{{capacitySymbol}}</span>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="dFlex">
                        <div class="table-status-progress-bar-wrapper progress" [ngStyle]="getProgressBarStyleWrapper(element)">
                          <div class="table-status-progress-line progress-bar" [ngStyle]="getProgressBarStyleInternal(element)"></div>
                        </div>
                        <div class='table-status-progress-bar-title'>
                          {{capacityDisplayType !=0 ? element['Last_updated_fill_level_sample']['fill_level_in_litters']: element['Last_updated_fill_level_sample']['fill_level_in_precent']}}
                          <span>{{capacitySymbol}}</span>
                        </div>
                      </div>
                    }
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
      </div>
    </div>
  </div>
}

@if (isMobile) {
  <div>
    @if (vehicles.length > 1) {
      <div class="mobile-back-arrow">
        <img class="arrow-back" (click)="goToDriverPlans()" rtlDiv src="assets/images/workplans-page/arrow-back.svg" alt="arrow-back">
        <span class="mobile-back-lbl">{{ 'SITE_MANAGMENT.BACK' | translate }}</span>
      </div>
    }
    <div class="mobile-driver-list-page">
      <div class="mobile-header" rtlDiv>
        <div class="mobile-title">{{'DRIVER_PLAN.BINS_LEFT' | translate}}: {{binsNotCollected}}</div>
        <div class="mobile-sub-title">{{'DRIVER_PLAN.LAST_UPDATE' | translate}}:
          {{(currentLang == 'iw' ? utilService.convertDateHebrew(lastUpdatedTime) : utilService.convertDateEnglish(lastUpdatedTime))}}
        </div>
        <div class="mobile-plan-info">
          <div class="plan-info">
            <img rtlDiv src="assets/images/workplans-page/site-name.svg" alt="site-name">
            <span>{{chosenPlan ? chosenPlan.site_name : ''}}</span>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="plan-info">
            <img rtlDiv src="assets/images/workplans-page/truck-name.svg" alt="truck-name">
            <span>{{'TRUCK_MAP.TRUCK' | translate }} {{chosenPlan ? chosenPlan.tablet_id : ''}}</span>
          </div>
        </div>
      </div>
      <div class="mobile-outside-table-border cdk-table">
          <div class="mat-table-wrapper">
            <table class="table" mat-table #table multiTemplateDataRows [dataSource]="dataSource" matSort matSortStart="asc" matSortActive="bin_collection_order_index"
            matSortDisableClear (matSortChange)="sortData($event)" matSortDirection="asc">
              <ng-container matColumnDef="bin_collection_order_index">
                <th class="mobile-th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_collection_order_index"># </th>
                <td class="mobile-td-value" mat-cell *matCellDef="let element" 
                [ngClass]="{'collected-bin':element.is_collected == 1}">
                  {{element ? element.bin_collection_order_index: ''}}
                </td>
              </ng-container>
              <ng-container matColumnDef="cluster_size">
                <th class="mobile-th-title" mat-header-cell *matHeaderCellDef mat-sort-header="num_of_bins_in_cluster">{{'DRIVER_PLAN.CLUSTER_SIZE' | translate}}</th>
                <td class="mobile-td-value" mat-cell *matCellDef="let element" 
                [ngClass]="{'collected-bin':element.is_collected == 1}">
                  {{element ? element.num_of_bins_in_cluster : ''}}
                </td>
              </ng-container>
              <ng-container matColumnDef="bin_name">
                <th class="mobile-th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_name">{{ 'LIST_COLUMNS.NAME' | translate }} </th>
                <td class="mobile-td-value" mat-cell *matCellDef="let element" 
                [ngClass]="{'collected-bin':element.is_collected == 1}">
                  <div class="mobile-flexOnly">
                    @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                      <div class="multiple-bins">
                        @for (bin of element.bins_in_cluster; track bin.bin_id) {
                          <div class="bin-item gap8">
                            <span>{{bin.bin_name}}</span>
                            <img src="{{getImg(bin)}}" alt="" />
                          </div>
                        }
                      </div>
                    } @else {
                      <span> {{element ? element.bin_name : ''}}</span>
                      <img src="{{element ? getImg(element) : ''}}" alt="" />
                    }
                  </div>                    
                </td>
              </ng-container>
              <ng-container matColumnDef="neighborhood">
                <th class="mobile-th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_neighbourhood">{{'LIST_COLUMNS.NEIGHBORHOOD' | translate}}</th>
                <td class="mobile-td-value" mat-cell *matCellDef="let element" 
                [ngClass]="{'collected-bin':element.is_collected == 1}">
                    <div>
                      @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                        <div class="multiple-bins">
                          @for (bin of element.bins_in_cluster; track bin.bin_id) {
                            <div class="bin-item">
                              <span>{{bin['Bin_location']['bin_neighbourhood']}}</span>
                            </div>
                          }
                        </div>
                      } @else {
                        <span> {{element ? element['Bin_location']['bin_neighbourhood'] : ''}}</span>
                      }
                    </div>                    
                </td>
              </ng-container>
              <ng-container matColumnDef="address">
                <th class="mobile-th-title" mat-header-cell *matHeaderCellDef mat-sort-header="bin_address"> {{ 'LIST_COLUMNS.ADDRESS' | translate }}</th>
                <td class="mobile-td-value" mat-cell *matCellDef="let element" 
                [ngClass]="{'collected-bin':element.is_collected == 1}">
                    <div class="address-val">
                      @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                        <div class="multiple-bins">
                          @for (bin of element.bins_in_cluster; track bin.bin_id) {
                            <div class="bin-item gap4">
                              <a class="wazeFrame" href='https://waze.com/ul?ll={{bin.Bin_location.bin_latitude}},{{bin.Bin_location.bin_longitude}}'><img class="mobile-wazeIcon" src="assets/images/dashboard/mobile-waze.svg" alt=""></a>
                              <span>{{bin['Bin_location']['bin_address']}}</span>
                            </div>
                          }
                        </div>
                      } @else {
                        <a class="wazeFrame" href='https://waze.com/ul?ll={{element.Bin_location.bin_latitude}},{{element.Bin_location.bin_longitude}}'><img class="mobile-wazeIcon" src="assets/images/dashboard/mobile-waze.svg" alt=""></a>
                        <span> {{element ? element['Bin_location']['bin_address'] : ''}}</span>
                      }
                    </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th class="mobile-th-title" mat-header-cell *matHeaderCellDef mat-sort-header="fill_level">{{ 'LIST_COLUMNS.STATUS' | translate }}</th>
                <td class="mobile-td-value" mat-cell *matCellDef="let element" 
                [ngClass]="{'collected-bin':element.is_collected == 1}">
                  <div>
                    @if (element.bins_in_cluster && element.bins_in_cluster.length > 1) {
                      <div class="multiple-bins">
                        @for (bin of element.bins_in_cluster; track bin.bin_id) {
                          <div class="bin-item">
                            <div class="dFlex">
                              <div class='table-status-progress-bar-title'>
                                {{capacityDisplayType !=0 ? bin['Last_updated_fill_level_sample']['fill_level_in_litters']: bin['Last_updated_fill_level_sample']['fill_level_in_precent']}}
                                <span>{{capacitySymbol}}</span>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="dFlex">
                        <div class='table-status-progress-bar-title'>
                          {{capacityDisplayType !=0 ? element['Last_updated_fill_level_sample']['fill_level_in_litters']: element['Last_updated_fill_level_sample']['fill_level_in_precent']}}
                          <span>{{capacitySymbol}}</span>
                        </div>
                      </div>
                    }
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsMobile"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsMobile"></tr>
            </table>
          </div>
      </div>
    </div>
  </div>
}